import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CharityFormsScreenComponent } from './charity-forms.component';
import { MaterialModule } from '../../theme/theme';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CharityFormsRouter } from './charity-forms.router';
import { CharityFormsEffects } from './state/charity-forms.effects';
import { reducers } from './state/charity-forms.selectors';
import { AppCommonModule } from 'src/app/common.module';

@NgModule({
    imports: [
        CharityFormsRouter,
        StoreModule.forFeature('charityForms', reducers),
    ],

    declarations: []
})
export class CharityFormsScreenModule { }